import { UseMutationOptions } from '@tanstack/react-query';

import { UpdateContentStatusInput } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import MutationKeys from './keys';

const useUpdateContentStatus = (
    contentId: string,
    mutateOptions?: UseMutationOptions<unknown, Error, UpdateContentStatusInput>
) =>
    useMutation<UpdateContentStatusInput>(
        MutationKeys.UPDATE_CONTENT_STATUS,
        new PathWithID(CuredApiPaths.CONTENT_UPDATE_STATUS, parseInt(contentId)),
        mutateOptions,
        ApiMethods.PATCH
    );

export default useUpdateContentStatus;
